import { createSelector } from '@ngrx/store';
import { getDCOState } from '../reducers';
import { _safe } from '../../../shared/utils/safe-get.method';

export const getSlot = createSelector(getDCOState, (state) => state && state.slots.entities[0]);

export const getDCOError = createSelector(getSlot, (state) => state && state.error);

export const getErrorSlotCode = createSelector(getDCOError, (state) => {
  return _safe(() => state.error.slots[0].requestProductStatusCode);
});

export const getHttpStatusReasonCode = createSelector(getDCOError, (state) => {
  return _safe(() => state.error.httpStatusReasonCode);
});
